import { render } from "./AdjustmentIcon.vue?vue&type=template&id=0c7bd0e8"
const script = {}

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__